import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";

let cache = null;
async function ids() { if (!cache) cache = api.get("/my/watchlist/ids").then((r) => r.data).catch(() => []); return cache; }

export default function HeartButton({ listingId, hearts = 0, size = "sm", className = "" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [on, setOn] = useState(false);
  const [count, setCount] = useState(hearts);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (user) ids().then((l) => setOn(l.includes(listingId))); }, [user, listingId]);

  const toggle = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!user) { nav("/login"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/sales/${listingId}/watch`);
      setOn(data.watching); setCount(data.hearts); cache = null;
      toast.success(data.watching ? "Added to your watchlist — we'll email you on price drops" : "Removed from watchlist");
    } catch (err) { toast.error(err?.response?.data?.detail || "Could not update"); } finally { setBusy(false); }
  };
  const big = size === "lg";
  return (
    <button type="button" onClick={toggle} disabled={busy} data-testid={`heart-${listingId}`} aria-pressed={on} title={on ? "Stop watching" : "Watch this car"}
      className={`inline-flex items-center gap-1.5 rounded-full border backdrop-blur-md transition-[transform,background-color,border-color] hover:scale-105 ${big ? "h-11 px-4 text-sm" : "h-8 px-2.5 text-xs"} ${on ? "bg-pink-500/20 border-pink-500/50 text-pink-300" : "bg-slate-950/60 border-slate-700 text-slate-200 hover:border-pink-500/50"} ${className}`}>
      <Heart className={`${big ? "w-4 h-4" : "w-3.5 h-3.5"} ${on ? "fill-current" : ""}`} />{big ? (on ? "Watching" : "Watch") : null}{count > 0 && <span className="font-mono" data-testid={`hearts-${listingId}`}>{count}</span>}
    </button>
  );
}
